import type { ReactNode } from 'react';

interface FieldProps {
  label: ReactNode;
  /** Small helper text under the field. */
  hint?: ReactNode;
  /** Error text; shown in the neg color when present. */
  error?: string;
  children: ReactNode;
  /** Render as a horizontal row on md+ breakpoints. */
  horizontal?: boolean;
}

export function Field({ label, hint, error, children, horizontal }: FieldProps) {
  return (
    <div className={horizontal ? 'grid gap-2 md:grid-cols-[1fr_45%] md:items-center md:gap-3' : ''}>
      <label className="block text-xs font-semibold uppercase tracking-wide text-ink-500 dark:text-ink-300">
        {label}
      </label>
      <div className={horizontal ? '' : 'mt-1'}>{children}</div>
      {error ? (
        <div className={`text-[11px] text-neg-600 dark:text-neg-500 ${horizontal ? 'md:col-span-2' : 'mt-1'}`}>
          {error}
        </div>
      ) : hint ? (
        <div className={`text-[11px] text-ink-500 dark:text-ink-300 ${horizontal ? 'md:col-span-2' : 'mt-1'}`}>
          {hint}
        </div>
      ) : null}
    </div>
  );
}

export function Label({ children }: { children: ReactNode }) {
  return (
    <span className="text-xs font-semibold uppercase tracking-wide text-ink-500 dark:text-ink-300">
      {children}
    </span>
  );
}
